export function User() {
    this.login = ''
    this.name = ''
    this.channels = []
    this.managed_users = []
    this.templates = []
    this.settings = {
        lang: 'en'
    }
    this.license_key = 'Not availalbe'
}


User.prototype.from_result = function(result) {
    this.login = result.data.login
    this.name = this.login
    return this
}
